import { Environment } from '@pbt/pbt-ui-components/src/constants/environment'

export const ENVIRONMENT_VARIABLES = {
  [Environment.PROD]: {
    SEGMENT_ENV_ID: 'AD29dLrdv7hifwMyYLhrhIkoDoLrqrwd',
    GTM_CONTAINER_ID: 'GTM-5X325N',
    GTM_EXTRA_PARAMS: '',
  },
  [Environment.MASTER]: {
    SEGMENT_ENV_ID: 'Ka0V13tSAcLGdeBsUpklOBAYE0cMEkNm',
    GTM_CONTAINER_ID: 'GTM-5X325N',
    GTM_EXTRA_PARAMS: '&gtm_auth=TYOfxaExwhF1-G3GSnFjmA&gtm_preview=env-160',
  },
  [Environment.STAGE]: {
    SEGMENT_ENV_ID: 'Ka0V13tSAcLGdeBsUpklOBAYE0cMEkNm',
    GTM_CONTAINER_ID: 'GTM-5X325N',
    GTM_EXTRA_PARAMS: '&gtm_auth=TYOfxaExwhF1-G3GSnFjmA&gtm_preview=env-160',
  },
  [Environment.DEV]: {
    SEGMENT_ENV_ID: 'Ka0V13tSAcLGdeBsUpklOBAYE0cMEkNm',
    GTM_CONTAINER_ID: 'GTM-5X325N',
    GTM_EXTRA_PARAMS: '&gtm_auth=TYOfxaExwhF1-G3GSnFjmA&gtm_preview=env-160',
  },
  [Environment.LOCAL]: {
    SEGMENT_ENV_ID: 'Ka0V13tSAcLGdeBsUpklOBAYE0cMEkNm',
    GTM_CONTAINER_ID: 'GTM-5X325N',
    GTM_EXTRA_PARAMS: '&gtm_auth=TYOfxaExwhF1-G3GSnFjmA&gtm_preview=env-160',
  },
}

